<template>
  <div>
    <div class="marginCenter">
      <div class="marginBom30 marginTop30 navTitle flex-yCenter flex-sb"></div>
      <div class="middle">
        <div class="flex-xCenter marginBom10">
          <img src="@/assets/images/index/success.png" alt="" />
        </div>
        <div class="flex-xCenter marginBom48">
          <span class="fsize32 fweight600 fcolor_green">提交成功</span>
        </div>
        <div class="flex-xCenter marginBom54">
          <el-button @click="goRecord" class="blueBtn2 btn300">查看进修记录</el-button>
        </div>
        <div class="remark fsize16">
          <div>说明：</div>
          <div>1.提交成功后，可在进修记录内查看已经提交的进修申请表</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      form: {},
      fileList: [],
      applyDeptList: [
        {
          deptName: "病理科",
          sdate: "2022-11-05",
          edate: "2022-11-05",
          teacherName: "王唰咯",
        },
      ],
      uploadList: [],
    };
  },
  created() {
    console.log(this.$route.query);
  },
  methods: {
    submit(e) {
      console.log(e);
    },
    goRecord() {
      this.$router.push({
        path: "/record/index",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.backIndex:hover {
  cursor: pointer;
}
.formTitle {
  margin: 50px 0px 30px 240px;
}
.step {
  margin-bottom: 48px;
}
::v-deep .el-textarea__inner {
  height: 95px;
  font-size: 18px;
}
::v-deep .middle {
  margin-bottom: 50px;
  .el-button--text {
    color: #2d53c8;
    &:hover {
      opacity: 0.9;
    }
  }
  .el-button--primary {
    width: 300px;
    height: 60px;
    color: #2d53c8;
    font-size: 22px;
    background: #ffffff;
    border-radius: 5px;
    border: 2px solid #2d53c8;
  }
}
</style>
